export function ie11() {
  let isIE11 = !!window.MSInputMethodContext && !!document.documentMode;
  if (isIE11) {
    var img = $('picture > img.img-fluid, picture > img.card-img-top');
    img.each(function () {
      $(this).css({height: $(this).height()});
      $(this).on('load', function () {
        $(this).css({height: 'auto'});
        $(this).css({height: $(this).height()});
      });
    });
  }
}



// WEBPACK FOOTER //
// ./scripts/components/ie11.js